import React from 'react';
import ErrorView from './ErrorView';

const NotFoundView = () => <ErrorView title="404: Not found" text="404: The page you are looking for isn’t here" />;

export default NotFoundView;
